import React from "react";
import MembershipDetails from "../../pt/pt-flow-new/users-info/MembershipDetails";

const MembershipHistory = ({ activeTab, userInfoData, rowData }) => {
  const transformedRowData = React.useMemo(() => {
    if (!rowData) return rowData;

    return {
      ...rowData,
      subscription_id:
        rowData?.pt_subscription_id || rowData?.subscription_id || "",
    };
  }, [rowData]);

  return (
    <MembershipDetails
      userInfoData={userInfoData}
      rowData={transformedRowData}
      activeTab={activeTab}
    />
  );
};

export default MembershipHistory;
